import { colors, fonts } from '@grupoboticario/flora-tokens/fidelidadeQuemDisseBerenice/web/ds'

export const fidelidadeQuemDisseBerenice = {
  colors,
  fonts,
}
